import {
  HeatingCostsInvoice,
  HeatingType
} from '../../frameworks_drivers/redux/reducers/onboardingInformation';
import { MetaItem } from '../index';

export * from './PriceClient';

export interface PricePayload {
  numberOfApartments: number | undefined;
  heatingCostsInvoice: HeatingCostsInvoice;
  centralHotWaterDelivery: boolean;
  heatingType: HeatingType;
  heatingSources: ReadonlyArray<string>;
  email: string;
  meta: MetaItem[];
  discountCode?: string | undefined;
}

export enum DiscountStatusEnum {
  NotApplicable = 'not_applicable',
  Applied = 'applied'
}

interface Product {
  name: string;
  price: number;
  currency: 'EUR' | string;
}

export interface PriceResponse {
  discountExpireDate: string | null;
  discountStatus: DiscountStatusEnum | string;

  products: Product;
}
